import { usePermission } from "app/hooks/usePermission";
import { PermissionLevel } from "app/zustand/assistantPermissionsStore";
import { getSessionStore } from "app/utils/sessionStore";

const RECEIVED_PATHS = ["/proposal/received"];
const PLAN_PATHS = ["/plan-summary", "/plans"];

function useOpenedFrom() {
  const previousPath = getSessionStore("previousPath");
  const from = typeof previousPath === "string" ? previousPath : "";
  return {
    received: RECEIVED_PATHS.some((p) => from.startsWith(p)),
    plans: PLAN_PATHS.some((p) => from.startsWith(p)),
  };
}

// Governs the write actions on a proposal (approve, comment, revoke, request changes).
// A plan opens the same proposal UI, but its actions stay under PIPELINE.PROPOSALS -
// PORTFOLIO.PLANS only decides whether the page is locked (see useProposalLockLevel).
export function useProposalPermissionLevel(): PermissionLevel {
  const openedFrom = useOpenedFrom();

  const { level: proposalsLevel } = usePermission("PIPELINE.PROPOSALS");
  const { level: pendingLevel } = usePermission("PIPELINE.PENDING_UNDERWRITING");

  return openedFrom.received ? pendingLevel : proposalsLevel;
}

// Governs whether the whole proposal page is locked behind the NONE overlay.
export function useProposalLockLevel(): PermissionLevel {
  const openedFrom = useOpenedFrom();

  const { level: proposalsLevel } = usePermission("PIPELINE.PROPOSALS");
  const { level: pendingLevel } = usePermission("PIPELINE.PENDING_UNDERWRITING");
  const { level: plansLevel } = usePermission("PORTFOLIO.PLANS");

  if (openedFrom.plans) return plansLevel;
  if (openedFrom.received) return pendingLevel;
  return proposalsLevel;
}

export default useProposalPermissionLevel;
